import { useState } from 'react';
import AccountCircleIcon from '../../../assets/icons/user-circle.svg';
import QuestionAnswerIcon from '../../../assets/icons/faq.svg';
import HelpIcon from '../../../assets/icons/question-circle.svg';
import ExitToAppIcon from '../../../assets/icons/signout.svg';
import AvatarMenu from './avatar-menu';
import Profile from '../../dashboard/profile';
import Dialog from '../dialog';
import l from '../../../lang';
import { openNewTabAndFocus } from '../../../utils';
import { Urls } from '../../../config/urls';
import { useDashboard } from '../../../store/dashboard';
import { useAuth } from '../../../store/auth';

const awfulHardcodedCountriesCodes = ['AR', 'CL', 'CO', 'MX'];

const AvatarOptions = () => {
  const { userMe, merchantMe } = useDashboard();
  const { sendLogout } = useAuth();
  const [open, setOpen] = useState(false);

  const openFAQs = () => {
    openNewTabAndFocus(Urls.faq);
  };

  const menuOptions = [
    {
      icon: <img src={AccountCircleIcon} />,
      text: l('avatarOptions.profile'),
      onClick: () => setOpen(!open),
    },
    {
      icon: <img src={QuestionAnswerIcon} />,
      text: l('avatarOptions.FAQ'),
      onClick: () => openFAQs(),
    },
    {
      icon: <img src={ExitToAppIcon} />,
      text: l('avatarOptions.logout'),
      onClick: () => sendLogout(),
    },
  ];

  if (!awfulHardcodedCountriesCodes.includes(merchantMe?.country || '')) {
    menuOptions.splice(2, 0, {
      icon: <img src={HelpIcon} />,
      text: l('avatarOptions.help'),
      onClick: () => window.openWidgetHelp(),
    });
  }

  return (
    <div>
      <AvatarMenu user={userMe?.name} items={menuOptions} />
      {open && (
        <Dialog
          dividers={false}
          unpaddingContent
          unpaddingFooter
          fullScreenMobile
          type="sm"
          body={<Profile onClose={() => setOpen(false)} />}
        />
      )}
    </div>
  );
};

export default AvatarOptions;
